import EmailIcon from '@mui/icons-material/Email';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Box, Fade, Menu, MenuItem, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import {
  getSocialIconByURL,
  WsColors,
  WsIconText,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import useCopyToClipboard from '../../candidates/talentpool/hooks/useCopyToClipboard';
interface IContactDropDownListing {
  view: 'email' | 'phone' | 'social';
  data: string[];
}

const Img = styled('img')(() => ({
  height: '22px',
  width: '22px',
  cursor: 'pointer',
  marginRight: '7px',
}));

const ContactDropDownListing = ({ view, data }: IContactDropDownListing) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [, copy] = useCopyToClipboard();
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const openUrlInNewTab = (url: string) => {
    const newWindow =
      url.indexOf('http') > -1 || url.indexOf('https') > -1
        ? window.open(url, '_blank', 'noopener,noreferrer')
        : window.open('//' + url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  return (
    <>
      {view === 'email' && (
        <Box>
          <WsIconText
            textCursor="pointer"
            popOverText="Email"
            icon={<EmailIcon sx={{ color: WsColors.TheBlues500, fontSize: '19px' }} />}
            textSize={WsTypoVariants.BODY1}
            onClick={() => copy(!isEmpty(data[0]) ? data[0] : 'Not added')}
            textColor={WsTypoColors.SECONDARY}
            text={!isEmpty(data[0]) ? data[0] : 'Not added'}
          />
          {data.length - 1 > 0 && (
            <WsTypography
              display="inline"
              cursor="pointer"
              onClick={handleClick}
              color={WsTypoColors.PRIMARY}
            >{`+${data.length - 1}`}</WsTypography>
          )}
        </Box>
      )}
      {view === 'phone' && (
        <Box>
          <WsIconText
            textCursor="pointer"
            popOverText="Contact Number"
            icon={<LocalPhoneIcon sx={{ color: WsColors.TheBlues500, fontSize: '19px' }} />}
            textSize={WsTypoVariants.BODY1}
            textColor={WsTypoColors.SECONDARY}
            onClick={() => copy(!isEmpty(data[0]) ? data[0] : 'Not added')}
            text={!isEmpty(data[0]) ? data[0] : 'Not added'}
          />
          {data.length - 1 > 0 && (
            <WsTypography
              onClick={handleClick}
              display="inline"
              cursor="pointer"
              color={WsTypoColors.PRIMARY}
            >{`+${data.length - 1}`}</WsTypography>
          )}
        </Box>
      )}
      {view === 'social' && !isEmpty(data) && (
        <Box>
          {data.map((url, index) => (
            <Img
              key={index}
              src={getSocialIconByURL(url)}
              alt={url}
              onClick={() => openUrlInNewTab(url)}
            />
          ))}
        </Box>
      )}
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {data.map((contact, index) => (
          <>
            {index != 0 && (
              <MenuItem key={index} onClick={() => copy(contact)}>
                {contact}
              </MenuItem>
            )}
          </>
        ))}
      </Menu>
    </>
  );
};

export default ContactDropDownListing;
